
import { LS_KEYS } from '../constants'
import ls from '../utils/local-storage'

export default fetch => ({
  __availiableShortcuts: [],
  __prevLang: '',
  getAvaliableShortCuts (loading) {
    const lang = ls.get(LS_KEYS.LOCALE)
    if (
      this.__availiableShortcuts &&
        this.__availiableShortcuts.length &&
        this.__prevLang === lang
    ) {
      return Promise.resolve([...this.__availiableShortcuts])
    } else {
      this.__prevLang = lang
      return fetch({
        url: '/api/v1/auth/GetAccountMainIconList',
        loading
      }).then(res => {
        if (res) {
          this.__availiableShortcuts = res
          return res
        }
      })
    }
  },
  setAvaliableShortcuts (shortcuts, loading) {
    return fetch({
      url: '/api/v1/auth/UpdateAccountIconRel',
      data: { codes: shortcuts.map(s => s.op_code) },
      loading
    }).then(res => {
      if (res) {
        this.__availiableShortcuts = [...shortcuts]
        return res
      }
    })
  },
  getAllShortcuts (loading) {
    return fetch({
      url: '/api/v1/auth/GetAllIconList',
      method: 'GET',
      loading
    })
  },
  __advertisements: [],
  getAdvertisement (loading) {
    if (this.__advertisements && this.__advertisements.length) {
      return Promise.resolve([...this.__advertisements])
    } else {
      return fetch({
        url: '/api/v1/auth/GetAdvertisement',
        method: 'POST',
        loading
      }).then(res => {
        if (res) {
          this.__advertisements = res
          return res
        }
      })
    }
  },
  getElearningUrl (loading) {
    return fetch({
      url: '/api/v1/auth/GetELearningUrl',
      method: 'GET',
      loading
    })
  }
})
